export default function TechnicalDetails() {
  const technicalSpecs = [
    {
      category: '水質管理',
      icon: 'ri-drop-line',
      specs: [
        { label: 'pH値', value: '7.0-8.0', unit: '自動調整' },
        { label: '溶存酸素', value: '6.0以上', unit: 'mg/L' },
        { label: '水温', value: '20-28', unit: '℃' },
        { label: 'アンモニア', value: '0.1以下', unit: 'mg/L' }
      ]
    },
    {
      category: '濾過システム',
      icon: 'ri-filter-3-line',
      specs: [
        { label: '生物濾過', value: '硝化バクテリア', unit: '処理' },
        { label: '物理濾過', value: 'マルチ層', unit: 'フィルター' },
        { label: '化学濾過', value: '活性炭', unit: '吸着' },
        { label: '殺菌処理', value: 'UV照射', unit: 'システム' }
      ]
    },
    {
      category: '循環効率',
      icon: 'ri-recycle-line',
      specs: [
        { label: '水再利用率', value: '90%以上', unit: '' },
        { label: '循環回数', value: '1-2回', unit: '/時間' },
        { label: '補給水量', value: '5-10%', unit: '/日' },
        { label: '排水量', value: 'ゼロ', unit: '' }
      ]
    },
    {
      category: '環境制御',
      icon: 'ri-settings-4-line',
      specs: [
        { label: '温度制御', value: '±0.5', unit: '℃精度' },
        { label: '照明管理', value: '自動調光', unit: 'システム' },
        { label: '給餌制御', value: '自動給餌', unit: '装置' },
        { label: '監視体制', value: '24時間', unit: 'モニタリング' }
      ]
    }
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E8F5E9] mb-6">
            <i className="ri-file-list-3-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">技術仕様</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            システムの技術詳細
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            高度な技術により、最適な飼育環境を維持し、<br className="hidden md:block" />
            高品質な水産物を安定的に生産します。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-20">
          {technicalSpecs.map((section, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#F5F9F6] to-white p-8 rounded-2xl border border-[#E8F5E9] shadow-lg"
            >
              <div className="flex items-center mb-6">
                <div className="w-14 h-14 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4">
                  <i className={`${section.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-[#1A2332]">{section.category}</h3>
              </div>
              <div className="space-y-4">
                {section.specs.map((spec, idx) => (
                  <div
                    key={idx}
                    className="bg-white p-4 rounded-xl border border-[#E8F5E9] flex items-center justify-between"
                  >
                    <span className="text-gray-700 font-medium">{spec.label}</span>
                    <div className="text-right">
                      <span className="text-[#2D7A3E] font-bold text-lg">{spec.value}</span>
                      {spec.unit && <span className="text-gray-600 text-sm ml-1">{spec.unit}</span>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#1A2332] to-[#2D3748] p-12 rounded-2xl text-white">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6">自動化・省力化技術</h3>
              <p className="text-lg opacity-95 mb-8 leading-relaxed">
                最新のIoT技術とAIを活用し、養殖作業の自動化と効率化を実現。少人数でも安定した運営が可能です。
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-smartphone-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">リモート監視</h4>
                    <p className="text-sm opacity-90">スマートフォンやPCから24時間いつでも施設の状態を確認</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-alarm-warning-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">異常検知アラート</h4>
                    <p className="text-sm opacity-90">水質や設備の異常を即座に検知し、自動で通知</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-line-chart-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">データ分析</h4>
                    <p className="text-sm opacity-90">蓄積されたデータを分析し、生産効率を継続的に改善</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="rounded-xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/e992ae69c678159795145233405a0ae5.jpg"
                  alt="自動化システム"
                  className="w-full h-[400px] object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}